import React from "react";
import { getProgramTypeIconClass } from "./functions";

const ItemIcon = ({ type, size = "", className = "" }) => {
  return (
    <div
      className={`card-course-icon ${size} ${getProgramTypeIconClass(type, true)} ${className}`}
    ></div>
  );
};

export default ItemIcon;
